import React from "react";
import { Switch, withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { connect } from "react-redux";
import PrivateRoute from '../privateRoute'
import PortfolioOverview from "./portfolioOverview";
import NewPortfolio from "./newPortfolio";
import Alerts from "./alerts";
import "./monitoring.scss";

class MonitoringLandingPage extends React.Component {
    render() {
        return (
            <div className="monitoring-root">
                <div className="content-root content-root-wide">
                    <Switch>
                        <PrivateRoute exact path={`${this.props.match.url}/portfolioOverview`} component={PortfolioOverview} />
                        <PrivateRoute exact path={`${this.props.match.url}/alerts/:id`} component={Alerts} />
                        <PrivateRoute exact path={`${this.props.match.url}/alerts`} component={Alerts} />
                        <PrivateRoute exact path={`${this.props.match.url}/newPortfolio`} component={NewPortfolio} />
                        <PrivateRoute exact path={`${this.props.match.url}/editPortfolio/:id`} component={NewPortfolio} />
                    </Switch>
                </div>
            </div>
        )
    }
}

export default connect(state => state.userContext, null)(withLocalize(withRouter(MonitoringLandingPage)));
